import { z } from "zod";
import { centavos, id } from "./comuns";

const ordem = z.number().int().min(0).max(9999);

const categoriaBase = z.object({
  nome: z.string().trim().min(2, { error: "Informe o nome da categoria" }).max(60),
  ordem,
  ativo: z.boolean(),
});

export const categoriaCriarSchema = categoriaBase.extend({
  ordem: ordem.optional().default(0),
  ativo: z.boolean().optional().default(true),
});
export type CategoriaCriarEntrada = z.input<typeof categoriaCriarSchema>;

export const categoriaEditarSchema = categoriaBase
  .partial()
  .refine((v) => Object.keys(v).length > 0, { error: "Nada para alterar" });
export type CategoriaEditarEntrada = z.input<typeof categoriaEditarSchema>;

const produtoBase = z.object({
  nome: z.string().trim().min(2, { error: "Informe o nome do produto" }).max(120),
  categoriaId: id,
  precoCentavos: centavos,
  ativo: z.boolean(),
  limiteEstoqueBaixo: z.number().int().min(0).max(100_000),
  ordem,
});

export const produtoCriarSchema = produtoBase.extend({
  ativo: z.boolean().optional().default(true),
  limiteEstoqueBaixo: produtoBase.shape.limiteEstoqueBaixo.optional().default(0),
  ordem: ordem.optional().default(0),
});
export type ProdutoCriarEntrada = z.input<typeof produtoCriarSchema>;

export const produtoEditarSchema = produtoBase
  .partial()
  .refine((v) => Object.keys(v).length > 0, { error: "Nada para alterar" });
export type ProdutoEditarEntrada = z.input<typeof produtoEditarSchema>;
